module.exports = "<p>404</p>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/not_found.vue
// module id = 115
// module chunks = 0